<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Escala de coma de glasgow"
    >
        <Form
            :data="data"
            :model="model"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="handleSave"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

import { object } from '@/mixins'

export default {
    components: { Form },
    data: () => ({
        model: null,
    }),
    methods: {
        open(item) {
            if (item) {
                this.model = {
                    id: item.id,
                    aberturaOcular: this.clone(item.aberturaOcular),
                    respostaVerbal: this.clone(item.respostaVerbal),
                    respostaMotora: this.clone(item.respostaMotora),
                    reatividadePupilar: this.clone(item.reatividadePupilar),
                    pontuacao: item.pontuacao,
                    resposta: item.resposta,
                    observacoes: item.observacoes,
                }
            } else {
                this.model = {
                    id: null,
                    aberturaOcular: { id: null, pontos: 0 },
                    respostaVerbal: { id: null, pontos: 0 },
                    respostaMotora: { id: null, pontos: 0 },
                    reatividadePupilar: { id: 3, pontos: 0 },
                    observacoes: null,
                }
            }

            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
    mixins: [object]
}
</script>